//@ts-check
//@ts-ignore
import StaffLogin from './staff-login.riot';
import { connect } from '@/common/lib/riot-redux';
import { createSelector } from 'reselect';
import { getOfficeFailure, getOfficeRequest, getOfficeSuccess, staffLoginFailure, staffLoginRequest, staffLoginSuccess } from './staff-login.action';
import { ajaxPost } from '../ajax';
import { STATUS_FAILURE_IDPASSWORD } from '@/common/constants';
import { router } from '@riotjs/route';
import storage from '@/common/storage';
import { openInfoDialog } from '@/common/components/kf-dialog';
import { getURLParameters } from '@/common/utils';

const getStaffOrder = createSelector(
  state => state.staffLogin.staffOrder,
  staffOrder => staffOrder === '' ? [] : staffOrder.split(',')
);

const getStaffById = createSelector(
  state => state.staffLogin.staffList,
  staffList => staffList.reduce((byId, staff) => (byId[staff.id] = staff, byId), {})
);

const getOrderedStaffs = createSelector(
  getStaffOrder,
  getStaffById,
  (staffOrder, staffById) => staffOrder.map(id => staffById[id]).filter(v => !!v)
);

const mapStateToProps = (state, props) => ({
  staffs: getOrderedStaffs(state),
  startMain: state.app.startMain,
  startSub: state.app.startSub,
  apiKey: props.apiKey,
  officeId: props.officeId,
  noLogging: props.noLogging,
});

const mapDispatchToProps = (dispatch, props) => ({
  async init() {
    if (props.staffId && props.password) {
      dispatch(staffLoginRequest());
      try {
        const payload = {
          method: 'login',
          officeId: props.officeId,
          apiKey: props.apiKey,
          staffId: props.staffId,
          pass: decodeURIComponent(props.password),
        };
        if (props.noLogging) payload.noLogging = props.noLogging;
        await ajaxPost('/stafflogin', payload);
        storage.setItem('loginAfter', '1');
        location.href = `/office/#${props.officeId}/`;
        dispatch(staffLoginSuccess());
      } catch (e) {
        dispatch(staffLoginFailure(e));
      }
    }
    dispatch(getOfficeRequest());
    try {
      const data = await ajaxPost('/stafflogin', {
        method: 'getOffice',
        officeId: props.officeId,
        apiKey: props.apiKey
      });
      storage.setOfficeId(props.officeId);
      storage.setApiKey(props.apiKey);
      dispatch(getOfficeSuccess(data));
    } catch (e) {
      if (e.status === STATUS_FAILURE_IDPASSWORD && storage.isMain()) {
        router.push('pc/check');
        return;
      }
      dispatch(getOfficeFailure(e));
    }
  },

  async login(payload) {
    dispatch(staffLoginRequest());
    try {
      await ajaxPost('/stafflogin', {
        method: 'login',
        officeId: props.officeId,
        apiKey: props.apiKey,
        staffId: payload.staffId,
        pass: payload.password
      });
      const keyStaffId = `${props.officeId}_staffId`;
      const keyStaffPass = `${props.officeId}_staffPass`;
      if (payload.saveInputCheck) {
        storage.setItem('staff_saveInputCheck', '1');
        storage.setItem(keyStaffId, payload.staffId);
        storage.setItem(keyStaffPass, payload.password);
      } else {
        storage.setItem('staff_saveInputCheck', '0');
        storage.removeItem(keyStaffId);
        storage.removeItem(keyStaffPass);
      }
      storage.setItem('loginAfter', '1');
      const redirectUrl = getURLParameters(location.href).redirect;
      if (redirectUrl) {
        location.href = decodeURIComponent(redirectUrl);
      } else {
        location.href = `/office/#${props.officeId}/`;
      }
      dispatch(staffLoginSuccess());
    } catch (e) {
      dispatch(staffLoginFailure(e));
    }
  },

  openInfoDialog(message) {
    dispatch(openInfoDialog(message));
  }
});

export default connect(StaffLogin, mapStateToProps, mapDispatchToProps);